import React from 'react';
import { Right } from './styled';
import enjoyYourContentImg from 'assets/img/block-1.png';
import modalEmptyImg from 'assets/img/block-2.png';
import spendFlixxImg from 'assets/img/block-4.png';
import { EnjoyYourContent } from 'components/Atoms';
import useResponsive from 'utils/hooks/useResponsive';
import useModal from 'utils/hooks/useModal';
import { useTranslation } from 'react-i18next';

const Index = () => {
  const { isTab } = useResponsive();
  const { t } = useTranslation();
  const { showModalType, TYPE_MODALS_DOWNLOAD } = useModal();
  let image, title, content;

  switch(showModalType){
    case TYPE_MODALS_DOWNLOAD.spendFlixx:
      image = spendFlixxImg;
      title = t("modal_spendFlixx_title");
      content = t("modal_spendFlixx_content");
      break;
    case TYPE_MODALS_DOWNLOAD.empty:
      image = modalEmptyImg;
      title = "";
      content = "";
      break;
    case TYPE_MODALS_DOWNLOAD.enjoyContent:
      image = enjoyYourContentImg;
      title = t("modal_enjoyYourContent_title");
      content = t("modal_enjoyYourContent_content");
      break;
    default:
      image = modalEmptyImg;
      title = "";
      content = "";
      return;
  };

  return (
    <>
      {(!isTab && showModalType) && (
        <Right>
          <EnjoyYourContent image={image} title={title} content={content} />
        </Right>
      )}
    </>
  )
}

export default Index
